<template>
  <div v-if="item">
    <div class="bg-white p-8 grid grid-cols-[3fr,4fr] gap-6 items-start">
      <div>
        <Picture :imgs="item.images"></Picture>
      </div>
      <div>
        <Information :item="item"></Information>
        <el-divider></el-divider>
        <Atrribute :info="item"></Atrribute>
        <el-divider></el-divider>
        <template v-if="item.hybcode">
          <div class="flex items-center">
            <span>{{ $t('发货时间') }}</span>
            <div class="flex items-center presell-time ml-5">
              <span class="iconfont icon-yushou text-red-600"></span>
              <span class="text-red-600">{{ $t('预售') }}</span>
              <span class="text-gray-500 pl-1">{{$t(item.supplier_info.presell_remark ? item.supplier_info.presell_remark : '预计三天内发货')}}</span>
            </div>
          </div>
          <el-divider></el-divider>
        </template>
        <Buy :curWh="curWh"></Buy>
      </div>
    </div>
    <div class="flex bg-white mt-4">
      <div class="w-70 p-8">
        <p class="text-left">{{ $t("猜你喜欢") }}</p>
        <div class="my-4">
          <List :span="1" :items="3" :data="data" v-slot="{ item }">
            <Item :item="item"></Item>
          </List>
        </div>
      </div>
      <div class="w-full border-l-2px pl-8">
        <Tab :pid="Number(p_id)" :item="item"></Tab>
      </div>
    </div>
  </div>
</template>
<script>
import Picture from "@/components/product/picture.vue";
import Information from "@/components/product/information.vue";
import Buy from "@/components/product/buy.vue";
import Atrribute from "@/components/product/param.vue";
import List from "@/components/base/list.vue";
import Item from "@/components//base/item.vue";
import Tab from "@/components/product/tab.vue";
import { watchEffect, ref, reactive ,computed} from "@vue/composition-api";

export default {
  components: { Picture, Buy, Information, Atrribute, List, Tab, Item },

  setup(props, ctx) {
    const item = ref();

    const data = reactive({ items: {} });
    const p_id = Number(ctx.root.$route.params.id);
    watchEffect(async (onInvalidate) => {
      onInvalidate(() => {
        item.value = null;
      });
      const d = await ctx.root.$callapi("getProductDetail", {
        pid: p_id,
      });
      item.value = d.data;

      data.items = d.data.comment_list.map((v) => v.product);
    });
    
    let curWh = computed(()=>{
      return item.value.hybcode ? 'presell' : 'origin'
    })

    return { item, data, p_id ,curWh};
  },
};
</script>
<style lang="scss" scoped>
.presell-time {
  border: 0.063rem solid #eaeaea;
  background: #ffffff;
  padding: 0.1rem 0.5rem;
}
</style>
